import { Container as PixiContainer } from 'pixi.js'
import { useEffect, useRef } from 'react'
import { Container } from '@pixi/react'
import { gameConfig } from '../config'
import { freeGameService } from '../domain/freeGame'

export enum SceneContainerNameType {
  SceneSpineContainer = 'SceneSpineContainer',
  BgSpine = 'bgSpine',
  TotalWinAmount = 'totalWinAmount',
  TabAnywhere = 'tabAnywhere',
  CoinRainAndThunder = 'CoinRainAndThunder',
}

export const SceneSpine = () => {
  const sceneRef = useRef<PixiContainer>()
  useEffect(() => {
    freeGameService.sceneContainer = sceneRef.current as PixiContainer
  }, [])
  return (
    <Container
      visible={false}
      name={SceneContainerNameType.SceneSpineContainer}
      ref={(el: PixiContainer | null) => {
        sceneRef.current = el as PixiContainer
      }}
    >
      <Container
        name={SceneContainerNameType.CoinRainAndThunder}
        x={gameConfig.resolution.width / 2}
        y={gameConfig.resolution.height / 2}
      />
      <Container
        name={SceneContainerNameType.BgSpine}
        eventMode="static"
        cursor="pointer"
        x={0}
        y={0}
      />

      <Container
        name={SceneContainerNameType.TotalWinAmount}
        eventMode="none"
        cursor="pointer"
        anchor={0.5}
        x={gameConfig.resolution.width / 2}
        y={900}
      />

      <Container
        name={SceneContainerNameType.TabAnywhere}
        eventMode="none"
        cursor="pointer"
        anchor={0.5}
        x={gameConfig.resolution.width / 2}
        y={1600}
      />
    </Container>
  )
}
